module.exports = __webpack_public_path__ + "static/media/diversity.f793a04e.png";